import { Input, InputField } from 'aos-ui-universal'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskTemplateNameField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()

    return (
        <Controller
            control={control}
            name='templateName'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.templateName.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('form.templateName.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <Input>
                        <InputField
                            value={field.value || ''}
                            onChangeText={(v: string) => field.onChange(v)}
                        />
                    </Input>
                </TaskFormField>
            )}
        />
    )
}
